import { ItemPill } from './'
import { Body, Box, Icon } from '../'

export const AddPill = ({ onClick, text, removeSpacing }) => (
  <ItemPill action index={3} onClick={onClick}>
    <Box fullWidth alignItems="center" gap={8} justifyContent={removeSpacing ? '' : 'space-between'}>
      <Box gap={8} alignItems="center">
        <Box radius="50%" height={45} width={45} background="var(--grey)" justifyContent="center" alignItems="center">
          <Icon icon="Plus" size={16} />
        </Box>
      </Box>
      <Body underline alt bold size={12}>{text}</Body>
    </Box>
  </ItemPill>
)